<template>
    <div>
        <div class="field">
            <div class="level is-mobile">
                <div class="level-left">
                    <div class="level-item">
                        <a class="button is-link" @click="periodeMoins" >&lt;</a>
                    </div>
                </div>
                <div class="control level-item has-text-centered">
                    <label class="radio">
                        <input type="radio" value="J" v-model="periodeSaisie.periode"
                        @change="change">
                        Journée
                    </label>
                    <label class="radio">
                        <input type="radio" value="M" v-model="periodeSaisie.periode"
                        @change="change">
                        Mois
                    </label>
                    <label class="radio">
                        <input type="radio" value="A" v-model="periodeSaisie.periode"
                        @change="change">
                        Année
                    </label>
                </div>
                <div class="level-right">
                    <div class="level-item">
                        <a class="button is-link" @click="periodePlus" >&gt;</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="field">
            <p class="control has-icons-left" v-if="periodeSaisie.periode=='J'">
                <input class="input" type="date" v-model="periodeSaisie.date"
                @change="change">
                <span class="icon is-small is-left">
                    <i class="fas fa-calendar-alt"></i>
                </span>
            </p>
        </div>
        <div class="field">
            <div class="select" v-if="periodeSaisie.periode=='M'">
                <select v-model="periodeSaisie.mois" @change="change">
                    <option value="1">Janvier</option>
                    <option value="2">Février</option>
                    <option value="3">Mars</option>
                    <option value="4">Avril</option>
                    <option value="5">Mai</option>
                    <option value="6">Juin</option>
                    <option value="7">Juillet</option>
                    <option value="8">Août</option>
                    <option value="9">Septembre</option>
                    <option value="10">Octobre</option>
                    <option value="11">Novembre</option>
                    <option value="12">Décembre</option>
                </select>
            </div>
        </div>
        <div class="field" v-if="periodeSaisie.periode=='M' || periodeSaisie.periode=='A'">
            <div class="control">
                <input class="input" type="text" placeholder="Année" v-model="periodeSaisie.annee"
                @keyup="change" >
            </div>
        </div>            
    </div>

</template>

<script>
export default {
    model: {
        prop: 'periode',
        event: 'change'
    },
    props: {
        periode: {}
    },
    data() {
        return {
            periodeSaisie: {}
        }
    },
    created() {
        if (this.periode != undefined && this.periode.periode != undefined ) {
            this.periodeSaisie = this.periode
        } else {           
            // Date du jour
            let now = new Date()
            let annee = now.getFullYear()
            let mois = now.getMonth()+1
            mois = "0" + mois
            mois = mois.slice(-2)
            let jour = ("0" + now.getDate()).slice(-2)
            
            // Par défaut en journalier, et init
            // mois et année
            this.periodeSaisie = {
                periode: 'J',
                date: annee + "-" + mois + "-" + jour,
                annee: annee,
                mois: parseInt(mois)
            }

            // Remonte les données au composant parent
            this.change()
        }
    },
    methods: {
        change() {
            // Résultat
            let result = {}
            // Journée
            if (this.periodeSaisie.periode != undefined) {
                result.periode = this.periodeSaisie.periode
                if (this.periodeSaisie.periode == 'J') {
                    if (this.periodeSaisie.date != undefined) {
                        let dateDecoupee = this.periodeSaisie.date.split("-")
                        result.jour = dateDecoupee[2]
                        result.mois = dateDecoupee[1]
                        result.annee = dateDecoupee[0]
                        result.timestampDebut = Date.parse(this.periodeSaisie.date + "T00:00:00")
                        result.timestampFin = result.timestampDebut + 86399000
                    }
                }
                if (this.periodeSaisie.periode == 'M') {
                    result.mois = ("0" + this.periodeSaisie.mois).slice(-2)
                    result.annee = this.periodeSaisie.annee
                    result.timestampDebut = Date.parse(result.annee + "-" + result.mois + "-01T00:00:00")
                    let annesSuivante = Number(result.annee)
                    let moisSuivant = Number(result.mois) + 1
                    if (moisSuivant > 12) {
                        annesSuivante ++
                        moisSuivant = 1
                    }
                    moisSuivant = ("0" + moisSuivant).slice(-2)
                    result.timestampFin = Date.parse(annesSuivante + "-" + moisSuivant + "-01T00:00:00") - 1000
                }
                if (this.periodeSaisie.periode == 'A') {
                    result.annee = this.periodeSaisie.annee
                    result.timestampDebut = Date.parse(result.annee + "-01-01T00:00:00")
                    result.timestampFin = Date.parse((Number(result.annee) + 1) + "-01-01T00:00:00") - 1000
                }

                this.$emit("change", result)
            }
        },
        periodeMoins() {
            if (this.periodeSaisie.periode == 'A') {
                this.periodeSaisie.annee--
            }
            if (this.periodeSaisie.periode == 'M') {
                this.periodeSaisie.mois--
                if (this.periodeSaisie.mois == 0) {
                    this.periodeSaisie.mois = 12
                    this.periodeSaisie.annee--
                }
            }
            if (this.periodeSaisie.periode == 'J') {
                let date = new Date(this.periodeSaisie.date)
                date.setDate(date.getDate()-1);
                this.periodeSaisie.date = date.toISOString().split('T')[0]
                
            }

            this.change()
            this.$emit("click")
        },
        periodePlus() {
            if (this.periodeSaisie.periode == 'A') {
                this.periodeSaisie.annee++
            }
            if (this.periodeSaisie.periode == 'M') {
                this.periodeSaisie.mois++
                if (this.periodeSaisie.mois == 13) {
                    this.periodeSaisie.mois = 1
                    this.periodeSaisie.annee++
                }
            }
            if (this.periodeSaisie.periode == 'J') {
                let date = new Date(this.periodeSaisie.date)
                date.setDate(date.getDate()+1);
                this.periodeSaisie.date = date.toISOString().split('T')[0]
                
            }

            this.change()
            this.$emit("click")
        }
    }
}
</script>

<style>

</style>
